  export const NAVBAR_WIDTH = 250;